import React from 'react';
import PropTypes from 'prop-types';
import useCaptureMedia from '../../hooks/useCaptureMedia';
import CaptureMediaGrid from './CaptureMediaGrid';

export default function FieldReportMediaPanel({ assetId }) {
  const { items, loading, error, fetchDownloadUrl, openCapture } = useCaptureMedia({
    assetId,
    enabled: Boolean(assetId),
  });

  return (
    <div className="card p-3 mt-4 min-w-0 overflow-hidden">
      <h5 className="fw-semibold mb-2">Field report media</h5>
      <p className="text-muted small mb-3">
        Photos captured by field engineers during workflows on this asset. Click a thumbnail to
        open the full image.
      </p>
      <CaptureMediaGrid
        items={items}
        loading={loading}
        error={error}
        fetchDownloadUrl={fetchDownloadUrl}
        onOpen={openCapture}
      />
    </div>
  );
}

FieldReportMediaPanel.propTypes = {
  assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
